import { createGlobalSettingsService } from './GlobalSettingsService.impl';

export const myGlobalSettingsService = createGlobalSettingsService();
